// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai-terminal"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M6.33 14.33L8.65686 12L6.33 9.67M13 16H18M22 11V20H2L2 4L12 4","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19 2.75L19.7 4.29996L21.25 5L19.7 5.70004L19 7.25L18.3 5.70004L16.75 5L18.3 4.29996L19 2.75Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai-terminal')
export default class AiTerminalIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-terminal',
    }
  }
}
